import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { OrdensalidaService } from '../../../services/ordensalida.service';
import { StockService } from '../../../services/stock.service';
import { FilterUrlService } from '../../../services/filter-url.service';
import { LoadService } from '../../../services/load.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit {
public order:any;
public groups:any[];
public bsModalRef:BsModalRef;
public tags_from_group:any[];
public group_seleccionado:any;
public alert:string;
public isopen:boolean;
public show_table:boolean;
public total_kg:number;
public total_boxes:number;
  constructor(private _loaddata:LoadService,private _route:Router,private _activatedRoute:ActivatedRoute, private _modalService:BsModalService, private ordenSalida:OrdensalidaService) {
    this.alert = '';
    this.isopen = false;
    this.tags_from_group = [];
    this.group_seleccionado = {};
    this.show_table = false;
    this.total_kg = 0;
    this.total_boxes = 0;
   }

  ngOnInit() {
        this._activatedRoute.params.subscribe(params => {
         this.alert = 'Cargando Orden...';
         this.isopen = true;
         this._loaddata.loadChange(40);
         this.ordenSalida.getOne(+params['id']).subscribe((response:any)=>{
           this.order = response;
           this.total_boxes = response.relationships.tags.data.length;
           console.log("ORDEN: ", this.order);
           this.ordenSalida.getTagsOrderDeleted(this.order.id).subscribe((response:any)=>{
             this.groups = response.data;
             this.show_table = true;
             this.total_kg = response.calculated.total;
             console.log("Grupos de Orden: ", response);
           },error=>{
             console.log("No se han podido obtener las cajas asociadas a la orden", error.error.error);
           });
           console.log("ORDEN: ", this.order);
           this.alert = 'Orden Cargada.';
           this.isopen = true;
           this._loaddata.loadChange(100);
         },error=>{
           this.volver();
           console.log("ERROR: ", error.error.error);
         });
      });
  }

  volver(){
    this._route.navigate(['/solicitud']);
  }

  mostrarDetalle(group:any){
    console.log("grupo sele: ",group);
    this.group_seleccionado = group;
    this.tags_from_group = group.relationships.tags.data;
  }

  openPDF(){
    console.log('orden',this.order);
    let url = this.order.attributes.pdf_url;
    window.open(url, '_blank');
  }

  verComentarios(template:TemplateRef<any>){
    this.bsModalRef = this._modalService.show(template);
  }

  cerrarModalVerComentarios(){
    this.bsModalRef.hide();
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/solicitudmovimiento/detail/detail.component.ts